import React, { useEffect, useState } from "react"
import Send from "../../core/communication"
import MessageNewsScreen from "../../screen/MessageNewsScreen"
import { customToast } from "../../components/Toast"
import { isMobile } from "react-device-detect"
import ModalAlert from "../../components/ModalAlert";
import { useScope } from "../SelectProjectCompanyContainer"

const templates = [
  `Veja nosso conteúdo:
{{1}}`,
]

const MessageNewsContainer = ({ selectedsUsers, defaultPostIds = [], modalNewsIsOpen, setModalNewsIsOpen }) => {
  const [posts, setPosts] = useState([])
  const [selectedPosts, setSelectedPosts] = useState([])
  const [usersToSendHeap, setUsersToSendHeap] = useState(null);
  const [filterPosts, setFilterPosts] = useState([])
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(false)
  const { scope, scopeType } = useScope()

  const onSearchTags = (e) => {
    const query = e.target.value
    let updatedList = [...posts]
    updatedList = updatedList.filter(
      (item) => item.title.toLowerCase().indexOf(query.toLowerCase()) !== -1,
    )
    setFilterPosts(updatedList)
  }

  useEffect(async () => {
    if (modalNewsIsOpen && !posts.length) {
      try {
        setLoading(true)
        const response = await Send.get(`/posts-projects/project/${scope?.id}`, `scopeType=${scopeType}`)
        setPosts(response)
      } catch (error) {
        customToast("Erro ao buscar conteúdos")
      }
      finally {
        setLoading(false)
      }
    }
  }, [modalNewsIsOpen])

  useEffect(() => {
    if (defaultPostIds && defaultPostIds.length > 0) {
      setSelectedPosts(defaultPostIds)

      const newHeap = defaultPostIds.map(postId => {
        return {
          postId,
          users: selectedsUsers.filter(row => row.postId === postId)
        }
      })

      setUsersToSendHeap(newHeap);
    }
    setFilterPosts(posts)
  }, [posts])

  useEffect(() => {
    setSelectedPosts([])
  }, [selectedsUsers, modalNewsIsOpen])

  const sendContentByHeap = async () => {
    setSaving(true)

    try {
      for await (const toSend of usersToSendHeap) {
        const news = posts.filter(item => toSend.postId && toSend.postId.includes(item.id));

        const response = await Send.post("/message", {
          news,
          templateId: "HXbc89e78c8c343fcf6839d096b48c011b",
          message: `https://manejechat.com.br/community/{{newsId}}?userId={{userId}}`,
          farmers: toSend.users || [],
          silentActiveSession: true,
          envioEmMassa: true
        })

        customToast(`Total de Produtores: ${toSend.users.length || 0} | Conteúdo: ${news[0]?.title}`, 'success');
      }
    } catch (error) {
      console.log("Erro ao enviar conteúdo: ", error);
      customToast("Erro ao enviar conteúdo. Cancelando próximos itens da fila.");
    }

    setSaving(false);
  }

  const sendMessage = async () => {
    setSaving(true);
    const news = posts.filter((item) => selectedPosts?.includes(item.id));


    if (news && news.length > 0) {
      try {
        const response = await Send.post("/message", {
          news,
          templateId: "HXbc89e78c8c343fcf6839d096b48c011b",
          message: `https://manejechat.com.br/community/{{newsId}}?userId={{userId}}`,
          farmers: selectedsUsers,
          silentActiveSession: true,
          envioEmMassa: true
        });
        if(
          isMobile
        ){
          ModalAlert.feedback({
            title: "Conteúdo enviado com sucesso!",
            buttons: false,
          })
        }else {
          customToast("Conteúdo enviado.", 'success');
        }

        setModalNewsIsOpen(false);
      } catch (error) {
        customSwal.fire({
          title: 'Erro',
          text: 'Erro ao enviar conteúdo',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    }

    setSaving(false);
  };


  const changeOptions = (event) => {
    const { checked, value } = event.currentTarget
    setSelectedPosts((prev) => (checked ? [...prev, value] : prev.filter((val) => val !== value)))
  }

  const changeCheckAll = (check, value) => {
    if (value === "true") {
      setSelectedPosts(
        check
          ? [...selectedPosts, check]
          : filterPosts.length === posts.length
            ? posts.map((item) => item.id)
            : filterPosts.map((item) => item.id),
      )
    } else {
      setSelectedPosts(check ? selectedPosts.filter((item) => item.id !== check.id) : [])
    }
  }

  const filteredPosts = () => {
    if (selectedPosts.length) {
      return filterPosts
        .filter((item) => selectedPosts?.includes(item.id))
        .map(({ id, title, image }) => ({
          value: id,
          label: title,
          image,
        }))
    }
    return
  }

  const removeSelectedContent = (value) => {
    const selected = selectedPosts.filter((item) => item !== value)
    setSelectedPosts(selected)
  }

  return (
    <MessageNewsScreen
      {...{
        open: modalNewsIsOpen,
        onSearchTags,
        selectedPosts,
        posts,
        filterPosts,
        filteredPosts,
        setOpen: setModalNewsIsOpen,
        changeOptions,
        removeSelectedContent,
        sendMessage,
        sendContentByHeap,
        saving,
        loading,
        changeCheckAll,
        hasDefaultPosts: defaultPostIds && defaultPostIds.length
      }}
    />
  )
}

export default MessageNewsContainer